<div class="main-container animated bounceInDown">
  <div class="row">
    <div class="col s12 l12">
      <div class="card user-permission">
        <div class="card-content">
          <div class="row">
            <span class="card-title">User Management</span>
          </div>
          <div class="row">
            <div class="col l11 s11 m11 search-project-field">
              <mat-form-field appearance="fill" floatLabel="always">
                <mat-label>Search projects</mat-label>
                <input matInput type="text" placeholder="Search for the project you would like to add users to" id="searchProject" #projectTerm
                  [formControl]="projectTermControl" [matAutocomplete]="projectAutocomplete" (input)="search(projectTerm.value)">
              </mat-form-field>
              <mat-autocomplete class="um-project-autocomplete" #projectAutocomplete="matAutocomplete"
                (optionSelected)="projectOptionSelected($event.option.value)">
                <mat-option *ngFor="let project of searchResults; trackBy: trackByProject" [value]="project.ProjectName">{{project.ProjectName}}</mat-option>
              </mat-autocomplete>
            </div>
          </div>
          
          <div class="row" *ngIf="IsProjectSelected == false">
            <div class="row">
              <div class="subheader">&nbsp;</div>
            </div>
          </div>
          <div class="row" *ngIf="IsProjectSelected == true">
            <div class="row">
              <div *ngIf="usersProject.controls.length == 0 " class="subheader"><i *ngIf="inErrorState" class="material-icons">error</i>{{ 'No users are assigned to this project yet' }}</div>
              <form novalidate [formGroup]="userManagementForm" *ngIf="usersProject.controls.length > 0">
                  <table class="highlight">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Last Login</th>
                        <th class="center">Remove User</th>
                      </tr>
                    </thead>
                    <tbody formArrayName="users">
                      <tr [formGroupName]="i" *ngFor="let h of userManagementForm.controls.users.controls; let i=index">
                        <td>{{ h.controls.name.value }}</td>
                        <td>{{ h.controls.userName.value }}</td>
                        <td>{{ h.controls.lastLoginDate.value }}</td>
                        <td class="center">
                          <a class="anchor" *ngIf="i >= 0"  (click)="removeItem(h)" matTooltip="Remove User" matTooltipPosition="above"><i class="material-icons center">remove</i></a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
              </form>
            </div>              
          </div>
          <div class="row search-users-row">
            <div class="col l11 s11 m11 search-users-field">
              <user-help></user-help>
              <mat-form-field appearance="fill" floatLabel="always" class="search-users-control">
                <mat-label>Search users</mat-label>
                <input matInput type="text" [placeholder]="searchUsersLabel" id="searchUsers"
                  [formControl]="userTermControl" [matAutocomplete]="usersAutocomplete"
                  #userTerm (input)="searchUser(userTerm.value)" (focus)="searchUser(userTerm.value)">
              </mat-form-field>
              <a class="search-users-help" (click)="openUserHelpModal()" routerLinkActive="active" matTooltip="help" matTooltipPosition="above"><i class="material-icons">info_outline</i></a>
              <mat-autocomplete class="um-users-autocomplete" #usersAutocomplete="matAutocomplete"
                (optionSelected)="userOptionSelected($event.option.value)">
                <mat-option *ngFor="let user of searchUsersResults; trackBy: trackByUser" [value]="user">
                  <div class="user-search-option">
                    <div class="user-search-name">{{user.name}}</div>
                    <div class="user-search-email">{{user.email}}</div>
                    <div class="user-search-status" [ngClass]="{'registered': user.status === 'Registered', 'not-registered': user.status !== 'Registered'}">{{user.status}}</div>
                    <div class="user-search-actions">
                      <a *ngIf="user.status !== 'Registered'" class="anchor" (click)="openUserOptions($event, user)">
                        <i class="material-icons">more_vert</i>
                      </a>
                    </div>
                  </div>
                </mat-option>
              </mat-autocomplete>
                <spinner-small [isRunning]="userSearchRunning" [extraSmall]="true" style="margin-left: 3rem; margin-top: -1rem; display:block;"></spinner-small>
            </div>
            <div class="col l1 s1 m1 add-user-col">
              <add-user></add-user>  
              <user-menu [userEmail]="selectedUserEmail" [userStatus]="selectedUserStatus" [clientX]="userMenuClientX" [clientY]="userMenuClientY"></user-menu>
            </div>
          </div> 
        </div>
        <div class="card-action right-align">
          <button type="button" mat-button class="negative um-footer-cancel"
            (click)="cancelClicked()" [disabled]="!hasPendingUserChanges">Cancel</button>
          <button type="button" mat-button class="affermative um-footer-save"
            (click)="saveUsersProject()"
            [disabled]="!(userManagementForm.valid && hasPendingUserChanges)">Save</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <br>Dirty: {{ userManagementForm.dirty }}
<br>Touched: {{ userManagementForm.touched }}
<br>Valid: {{ userManagementForm.valid }}
<br>Project Form: {{ this.userManagementForm.value | json }} -->
